import { useEffect } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router";

type Props = WithTranslation & RouteComponentProps;

type AvailableLanguages = "en" | "de" | "fr";

const TermsAndConditionsDocumentPage = (props: Props) => {
  useEffect(() => {
    const lng = props.i18n.language as AvailableLanguages;
    const baseUrl = `${window.location.origin}/documents`;
    let url = `${baseUrl}/adey-sense-tnc-en.pdf`;

    if (lng === "de" || lng.startsWith("de")) {
      url = `${baseUrl}/adey-sense-tnc-de.pdf`;
    } else if (lng === "fr" || lng.startsWith("fr")) {
      url = `${baseUrl}/adey-sense-tnc-fr.pdf`;
    }

    window.location.href = url;
  }, [props.i18n.language]);

  return null;
};

export default withRouter(withTranslation()(TermsAndConditionsDocumentPage));
